export var AppNames;
(function (AppNames) {
    AppNames["TRANSACTIONS_MANAGEMENT_UI_APP_NAME"] = "transactions-management-ui";
    AppNames["AUDIT_UI_APP_NAME"] = "audit-ui";
    AppNames["IDENTITY_UI_APP_NAME"] = "identity-ui";
    AppNames["ADMIN_UI_APP_NAME"] = "admin-ui";
    AppNames["PAYMENT_UI_APP_NAME"] = "payment-ui";
})(AppNames || (AppNames = {}));
export var EnvNames;
(function (EnvNames) {
    EnvNames["stage"] = "stage";
    EnvNames["test"] = "test";
    EnvNames["prod"] = "prod";
    EnvNames["pen-test"] = "pen-test";
})(EnvNames || (EnvNames = {}));
/**
 * @param envName - Environment name
 * @returns Whether or not environment name is valid
 */
function isValidEnvName(envName) {
    return !!envName && Object.keys(EnvNames).includes(envName);
}
/**
 * Load environment name with defaults. Order:
 * 1. NEXT_PUBLIC_APP_ENV environment variable
 * 2. Default to "stage" (other options not used if invalid)
 * @param envInput - Environment input (from initAnalytics). Defaults to
 * @returns Valid app name
 */
export function getEnv(envInput = process.env.NEXT_PUBLIC_APP_ENV) {
    if (process.env.APP_CONFIG_ENV) {
        const { APP_CONFIG_ENV } = process.env;
        if (isValidEnvName(APP_CONFIG_ENV)) {
            return APP_CONFIG_ENV;
        }
        console.warn(`[@side/analytics] "APP_CONFIG_ENV" value of "${APP_CONFIG_ENV}" not valid for analytics, attempting to fallback`);
    }
    // Load from next environment variable
    if (process.env.NEXT_PUBLIC_APP_CONFIG_ENV) {
        const { NEXT_PUBLIC_APP_CONFIG_ENV } = process.env;
        if (isValidEnvName(NEXT_PUBLIC_APP_CONFIG_ENV)) {
            return NEXT_PUBLIC_APP_CONFIG_ENV;
        }
        console.warn(`[@side/analytics] "NEXT_PUBLIC_APP_CONFIG_ENV" value of "${NEXT_PUBLIC_APP_CONFIG_ENV}" not valid for analytics, attempting to fallback`);
    }
    // Load from default next environment variable
    if (process.env.APP_ENV) {
        const { APP_ENV } = process.env;
        if (isValidEnvName(APP_ENV)) {
            return APP_ENV;
        }
        console.warn(`[@side/analytics] "APP_ENV" value of "${APP_ENV}" not valid for analytics, attempting to fallback`);
    }
    // Fallback to stage if nothing set
    if (!envInput) {
        console.warn('[@side/analytics] "APP_CONFIG_ENV" env variable and "env" parameter not passed to initAnalytics, falling back to stage');
        return EnvNames.stage;
    }
    // Fallback to stage if app name is not valid
    if (envInput && !isValidEnvName(envInput)) {
        console.warn(`[@side/analytics] env value of "${envInput}" passed to initAnalytics is not valid, falling back to "stage"`);
        return EnvNames.stage;
    }
    // Otherwise use envInput
    return envInput;
}
